// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutItem-module_root_1xI7W","grow":"LayoutItem-module_grow_2yLfp"};